import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { API } from '../../../API';
import { showRequestError } from '../../../utils/requestError';
import './Filter.scss';
import { TagsHierarchyChooser } from '../../../components/TagsHierarchyChooser/TagsHierarchyChooser';
import { ExcludeSwitch } from '../../SearchPage/Filter/ExcludeSwitch';
import styles from './Filter.module.scss';

export const TagsChooser = ({onChange, selected, exclude, onExcludeChange}) => {
  const { t } = useTranslation();

  const [tags, setTags] = useState(null);

  const fetchSourceTags = useCallback(() => {
    API.fetch('GET', `/API/v1/source_tags/public`).then(
      (data) => {
        setTags(data);
      },
    ).catch((e) => showRequestError(e, t('Actor tags')));
  }, []);

  useEffect(() => {
    fetchSourceTags()
  }, [])

  const handleSelect = () => {
    if(tags?.objects?.length !== selected.length) {
      onChange(tags?.objects?.map(i => i.full_path))
    } else {
      onChange([])
    }
  }

  return (
    <div className="chooser">
      {onExcludeChange && (
        <div className={styles.excludeFilterContainer}>
          <ExcludeSwitch
            id='source-tags-switch'
            value={exclude || false}
            onChange={onExcludeChange}
            color='red'
          />
        </div>
      )}
      <TagsHierarchyChooser selected={selected} onChange={onChange} mode="legacy" />
    </div>
  );
};
